import { CheckmarkType } from '@eika/checkmark-list';

import { KortbetjeningText } from '@hooks/use-text';

export const getInfoBannerCheckmarks = ({
    googleWalletInfoBannerCheckMarkSimple,
    googleWalletInfoBannerCheckMarkShopping,
    googleWalletInfoBannerCheckMarkBothTypes,
}: KortbetjeningText): CheckmarkType[] => [
    {
        label: googleWalletInfoBannerCheckMarkSimple,
        checked: true,
    },
    {
        label: googleWalletInfoBannerCheckMarkShopping,
        checked: true,
    },
    {
        label: googleWalletInfoBannerCheckMarkBothTypes,
        checked: true,
    },
];
